import { render, staticRenderFns } from "./WizardTab.vue?vue&type=template&id=6ed5b27e&scoped=true&"
import script from "./WizardTab.vue?vue&type=script&lang=js&"
export * from "./WizardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed5b27e",
  null
  
)

export default component.exports